'use client';
import React, { useRef } from 'react';
import { Grid, GridItem, Text, Button, Box } from '@chakra-ui/react';
import Image from 'next/image';
import heroimg from '/public/images/hero-5x2.jpg';
import heroimgSm from '/public/images/gym/hero-4x6mobile.jpg';
import Link from 'next/link';

export default function Hero() {
  const heroRef = useRef(null); // To get the reference to the hero container

  const handleScrollUp = () => {
    // Scroll the page up by the height of the hero container
    const packagesSection = document.getElementById('packages');
    if (packagesSection) {
      packagesSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
      {/* Desktop and Mobile sections */}
      <Box ref={heroRef}>
        <Grid
          display={{ base: 'none', md: 'grid' }}
          templateColumns="1fr 1fr"
          templateRows="1fr 1fr"
        >
          <GridItem
            colStart={1}
            colEnd={3}
            rowStart={1}
            rowEnd={3}
            width="100vw"
          >
            <Image
              src={heroimg}
              alt="Hero Image"
              width="auto"
              height="auto"
              placeholder="blur"
            />
          </GridItem>
          <GridItem
            colStart={1}
            colEnd={3}
            rowStart={1}
            rowEnd={2}
            zIndex="1"
            display="flex"
            justifyContent="end"
            textAlign="start"
            flexDirection="column"
            ml="5vw"
          >
            <Text
              fontSize="4.5vw"
              fontWeight="light"
              color="white"
              lineHeight="1em"
              mb="3"
            >
              Gym Mirrors
            </Text>
            <Text
              fontSize="4.5vw"
              fontWeight="bold"
              color="white"
              lineHeight="1em"
            >
              Delivery &amp; Installation
            </Text>
          </GridItem>
          <GridItem
            colStart={1}
            colEnd={2}
            rowStart={2}
            rowEnd={3}
            zIndex="1"
            ml="5vw"
            mr="15vw"
          >
            <Text
              fontSize="1.0vw"
              fontWeight="light"
              color="white"
              mt="1.2vw"
              lineHeight="1.2em"
              textAlign="start"
            >
              We offer nationwide installation services to ensure a seamless
              experience for our clients.
            </Text>
            <Text
              fontSize="1.0vw"
              fontWeight="light"
              color="white"
              mt="1.2vw"
              lineHeight="1.2em"
              textAlign="start"
            >
              You can rest assured knowing that your mirror will be delivered
              and hung safe and securely all by our in-house team.
            </Text>
            <Box textAlign="start">
              <Button
                onClick={() => handleScrollUp()}
                fontSize={{ base: '2vw', md: '1.2vw', lg: '1.2vw' }}
                borderRadius="2.5vw"
                padding="1.8vw 6vw"
                mt="1.5vw"
              >
                Get Started
              </Button>
            </Box>
          </GridItem>
        </Grid>

        {/* Mobile Layout */}
        <Grid
          display={{ base: 'grid', md: 'none' }}
          templateColumns="1fr"
          templateRows="20% 45% 35%"
        >
          <GridItem
            colStart={1}
            colEnd={2}
            rowStart={1}
            rowEnd={4}
            width="100vw"
          >
            <Image
              src={heroimgSm}
              alt="Hero Image"
              width="auto"
              height="auto"
            />
          </GridItem>
          <GridItem
            colStart={1}
            colEnd={2}
            rowStart={1}
            rowEnd={2}
            zIndex="1"
            display="flex"
            textAlign="center"
            justifyContent="end"
            flexDirection="column"
          >
            <Text
              fontSize="7vw"
              fontWeight="light"
              color="white"
              lineHeight="1em"
              mb="1"
            >
              Gym Mirrors
            </Text>
            <Text
              fontSize="7vw"
              fontWeight="bold"
              color="white"
              lineHeight="1em"
            >
              Delivery &amp; Installation
            </Text>
          </GridItem>
          <GridItem
            colStart={1}
            colEnd={2}
            rowStart={3}
            rowEnd={4}
            zIndex="1"
            m="0 6vw"
          >
            <Text
              fontSize="4.0vw"
              fontWeight="light"
              color="white"
              mt="1.2vw"
              lineHeight="1.2em"
              textAlign="start"
            >
              We offer nationwide installation services to ensure a seamless
              experience for our clients.
            </Text>
            <Text
              fontSize="4.0vw"
              fontWeight="light"
              color="white"
              mt="1.2vw"
              lineHeight="1.2em"
              textAlign="start"
            >
              You can rest assured knowing that your mirror will be delivered
              and hung safe and securely all by our in-house team.
            </Text>
            <Box textAlign="center">
              <Button
                onClick={() => handleScrollUp()}
                fontSize="4.4vw"
                borderRadius="8vw"
                padding="6vw 6vw"
                mt="5vw"
                width="100%"
                fontWeight={500}
                textTransform={'uppercase'}
              >
                Get Started
              </Button>
            </Box>
          </GridItem>
        </Grid>
      </Box>
    </>
  );
}
